"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationTemplateContext = void 0;
const react_1 = require("react");
exports.NotificationTemplateContext = (0, react_1.createContext)(undefined);
//# sourceMappingURL=notification-template-context.js.map